import styled from 'styled-components'
import IconModalClose from '~/assets/images/x.png'
import { ReactComponent as Warning } from '~/assets/images/token-warning.svg'
import { ReactComponent as Compass } from '~/assets/images/compass.svg'
import { ReactComponent as Blocked } from './assets/blocked.svg'
import { ReactComponent as Checked } from '~/assets/images/checkedRectangle.svg'
import {
  DividerProps,
  IconCloseProps,
  TextSymbolProps,
  TypographyProps,
} from './types'

export const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 102;
  background: radial-gradient(
    rgba(0, 0, 0, 0.4),
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0.6)
  );
  overflow: scroll;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ModalContent = styled.div`
  background: #ffffff;
  border-radius: 20px;
  width: 435px;
  position: absolute;
  padding: 18px;

  @media screen and (max-width: 600px) {
    width: calc(100vw - 20px);
  }
`

export const StyledTokenExplorerWrapper = styled.div`
  cursor: pointer;
`

export const StyledConfirmArea = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 8px;
`

export const ModalButton = styled.button`
  cursor: pointer;
  outline: none;
  color: #ffffff;
  font-weight: 500;
  font-size: 15px;
  line-height: 16px;
  background: #5f4dbc;
  border-radius: 32px;
  padding: 14.5px 0;
  width: 100%;
  border: none;

  &.disabled {
    background: #beb8e2;
    cursor: not-allowed;
  }
`

export const IconClose = styled.img.attrs(() => ({
  src: IconModalClose.src,
}))<IconCloseProps>`
  width: 24px;
  height: 24px;
  cursor: pointer;
  background: transparent;
  transition: background ease-in-out 0.2s;
  border-radius: 4px;
  position: absolute;
  top: 19px;
  ${({ position }) => (position === 'left' ? 'left: 17px;' : 'right: 17px;')}
  cursor: pointer;

  &:hover {
    background: #f5f7fb;
  }
`

export const IconWarning = styled(Warning)`
  width: 48px;
  height: 48px;
  margin: 27px auto 10px;
  display: block;
`

export const IconBlocked = styled(Blocked)`
  margin: 27px auto 10px;
  display: block;
`

export const TextWarningTitle = styled.p`
  margin-bottom: 8px;
  font-weight: 500;
  font-size: 15px;
  line-height: 24px;
  text-align: center;
  color: #191c1e;
`

export const TextWarning = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #191c1e;
  text-align: center;
`

export const WaringToken = styled.div`
  background: #fafafc;
  border-radius: 20px;
  padding: 20px 20px 15px;
  margin-top: 16px;
  margin-bottom: 20px;
`

export const TextSymbol = styled.span<TextSymbolProps>`
  font-weight: normal;
  font-size: ${({ fontSize }) => fontSize + 'px' || '12px'};
  line-height: 20px;
  letter-spacing: 0.2px;
  color: #191c1e;
  min-width: 38px;
  margin: 0;
  margin-right: 9px;
`

export const DegenTag = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: 140%;
  border: 1px solid #d05353;
  border-radius: 18px;
  padding: 4px 8px;
  color: #d05353;
  margin-left: auto;
`

export const Typography = styled.p<TypographyProps>`
  font-weight: ${({ fontWeight }) => fontWeight || 400};
  font-size: ${({ fontSize }) => fontSize + 'px' || '12px'};
  line-height: ${({ lineHeight }) => lineHeight + 'px' || 1};
  color: ${({ color }) => color || '#191c1e'};
  text-align: ${({ textAlign }) => textAlign || 'left'};
  word-break: break-all;
`

export const Divider = styled.div<DividerProps>`
  border-width: ${({ stroke }) => (stroke ? stroke + 'px' : '0.5px')};
  border-style: solid;
  border-color: ${({ fill }) => fill || '#eaecf6'};
  border-bottom: none;
  margin: ${({ spacing }) =>
      typeof spacing !== 'undefined' ? spacing + 'px' : '20px'}
    0;
`

export const IconNav = styled(Compass)`
  width: 16px;
  height: 16px;
  display: block;
  margin-left: auto;
  cursor: pointer;
`

export const IconChecked = styled(Checked)``

export const IconUnchecked = styled.span`
  width: 14px;
  height: 14px;
  background: #fafbfc;
  border: 1px solid #eaecf5;
  border-radius: 4px;
`
